import React from 'react'
import { Header1, Text } from '../../styles/Components'
import Button from '../Button'
import { gsColors } from '../../styles/Variables'

const HeaderContent = ({ handleClick }) => {
  return (
    <>
      <Header1 color={gsColors.salmon} margin="0 0 24px">
        <span className="web-header-text">
          EVENTS,
          <br />
          GROUP GLAM +<br />
          PHOTOSHOOTS
        </span>
        <span className="mobile-header-text">
          EVENTS, GROUP GLAM
          <br />+ PHOTOSHOOTS
        </span>
      </Header1>
      <Text
        color={gsColors.white}
        lineHeight="138%"
        fontSize={22}
        margin="0 0 48px"
      >
        Custom, on-demand hair and makeup services for groups of 2 to 500+—from
        private events and corporate functions to on-set services.
      </Text>
      <Button
        onClick={handleClick}
        large
        color={gsColors.salmon}
        style={{ color: gsColors.cobalt }}
      >
        Get Started
      </Button>
    </>
  )
}

export default HeaderContent
